import { useEffect, useMemo, useState } from 'react';
import { getRequest } from 'apis/ApiInstence';

const getCityNames = (response) => {
    const payload = response?.data;
    const cities = Array.isArray(payload) ? payload : payload?.data;

    if (!Array.isArray(cities)) return [];

    return [...new Set(cities
        .map((city) => (typeof city === 'string' ? city : city?.name || city?.city))
        .filter(Boolean))];
};

const useCities = () => {
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const cityOptions = useMemo(() => cities.map((city) => ({ value: city, label: city })), [cities]);

    useEffect(() => {
        let mounted = true;

        const loadCities = async () => {
            try {
                const response = await getRequest('city');
                if (mounted) setCities(getCityNames(response));
            } catch (error) {
                if (mounted) setCities([]);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        loadCities();
        return () => {
            mounted = false;
        };
    }, []);

    return { cities, cityOptions, loading };
};

export default useCities;
